export default (function (value) {
  return value;
});


//////////////////
// WEBPACK FOOTER
// ./~/redux-blueprint/~/redux-actions/es/utils/identity.js
// module id = 355
// module chunks = 1